import React from "react";
import "../../styles/Aboutbriefly.css";
import marketingimg from "../../assets/images/Home-Banner-new.webp";

const Aboutbriefly = () => {
  return (
    <section className="marketing-section">
      <div className="marketing-content">
        <div className="section-badge">Why Choose EmpowerWeb?</div>
        <h2>Proven Excellence Backed by 100+ Successful Clients</h2>
        <p>
          We don’t just build websites or run campaigns we build complete
          digital growth systems that help your business attract customers,
          generate leads, and scale faster.
        </p>
        <ul className="features-list">
          <li>
            <div className="feature-icon">✓</div>
            <div className="feature-text">
              <strong>Result-Driven Strategy</strong>
              <p>
                We focus on what actually matters leads, conversions, and sales.
                Every design, campaign, and strategy is built to grow your
                business, not just look good.
              </p>
            </div>
          </li>
          <li>
            <div className="feature-icon">✓</div>
            <div className="feature-text">
              <strong>AI-Powered Solutions</strong>
              <p>
                We use modern AI tools and automation to make your business
                smarter, faster, and future-ready. From chatbots to automated
                workflows, everything is optimized for efficiency.
              </p>
            </div>
          </li>
          <li>
            <div className="feature-icon">✓</div>
            <div className="feature-text">
              <strong>Fast Delivery with Professional Quality</strong>
              <p>
                We respect your time. Projects are delivered quickly without
                sacrificing performance, design quality, or functionality.
              </p>
            </div>
          </li>
          <li>
            <div className="feature-icon">✓</div>
            <div className="feature-text">
              <strong>Ongoing Support & Growth Partnership</strong>
              <p>
                We don’t disappear after delivery. We provide continuous
                support, updates, and improvements to help your business grow
                long-term.
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div className="marketing-illustration">
        <img src={marketingimg} alt="Digital Solutions Illustration" />
      </div>
    </section>
  );
};

export default Aboutbriefly;
